const DAY_MS = 86_400_000;
const NEW_PERMIT_WINDOW_DAYS = 30;

/** A permit earns the consumer-facing New badge for its first 30 calendar days. */
export function isNewPermit(issuedDate: string, now = new Date()) {
  const issuedAt = Date.parse(`${issuedDate.slice(0, 10)}T12:00:00Z`);
  const today = Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate());
  return Number.isFinite(issuedAt) && issuedAt <= today && issuedAt >= today - NEW_PERMIT_WINDOW_DAYS * DAY_MS;
}
